import React from 'react';
import '../Utilities/reset.css'
import TopCarousel from '../topCarousel/topCarousel';
import './Header.css'

function Header() {
    return (
        <div className="header-container">
            <h2 className="header-carousel">
                <TopCarousel />
            </h2>
        </div>
    );
}

export default Header;